var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPulseLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 370,
    height: 233,
    viewBox: "0 0 370 233",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.0361 41.3879L127.865 25.5732V157.515L71.0361 173.329V41.3879Z",
    fill: "#D09CE7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.524 72.6438L298.354 56.8291V188.771L241.524 204.585V72.6438Z",
    fill: "#FFA100"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.663 24.9386L229.59 0V208.061L138.663 233V24.9386Z",
    fill: "#2574DB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M179.96 150.597V84.2966H189.431V150.597H179.96ZM161.017 136.39V98.5039H170.488V136.39H161.017ZM198.903 136.39V98.5039H208.374V136.39H198.903ZM142.074 122.183V112.711H151.545V122.183H142.074ZM217.846 122.183V112.711H227.318V122.183H217.846Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M297 200.908L295.308 199.368C289.3 193.92 285.333 190.327 285.333 185.917C285.333 182.323 288.156 179.5 291.75 179.5C293.78 179.5 295.728 180.445 297 181.938C298.271 180.445 300.22 179.5 302.25 179.5C305.843 179.5 308.666 182.323 308.666 185.917C308.666 190.327 304.7 193.92 298.691 199.38L297 200.908Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9997 47.9083L70.308 46.3683C64.2997 40.92 60.333 37.3267 60.333 32.9167C60.333 29.3233 63.1563 26.5 66.7497 26.5C68.7797 26.5 70.728 27.445 71.9997 28.9383C73.2713 27.445 75.2197 26.5 77.2497 26.5C80.843 26.5 83.6663 29.3233 83.6663 32.9167C83.6663 37.3267 79.6997 40.92 73.6913 46.38L71.9997 47.9083Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulseLogo);
export default __webpack_public_path__ + "static/media/pulse-logo.f7ec6cc17e8641a8091ab3d60562aa9b.svg";
export { ForwardRef as ReactComponent };